import React from 'react';
import { Table, Text } from '@ui';
import { translate } from '@utils/i18n';
const NAMESPACE = 'features.settings.integrations.tce_template_diagnostic';
function VerdictCell({ item }) {
    return (React.createElement(Text, { variant: "x-small" },
        React.createElement("i", { className: item.kept ? 'fa-solid fa-check' : 'fa-light fa-triangle-exclamation', "aria-hidden": "true" }),
        ` ${translate(item.kept ? 'kept' : 'dropped', { namespace: NAMESPACE })}`));
}
/**
 * One row per template TCE returned, including the ones the submission wizard
 * discards. The discarded rows are the reason this table exists, so they sort
 * first and carry the reason they were dropped.
 */
function TemplateVerdictTable({ templates }) {
    const columns = [
        { dataKey: 'templateId', label: translate('column_template_id', { namespace: NAMESPACE }), width: '90px' },
        { dataKey: 'childType', label: translate('column_child_type', { namespace: NAMESPACE }), width: '120px' },
        { dataKey: 'name', label: translate('column_name', { namespace: NAMESPACE }), width: '190px' },
        {
            dataKey: 'kept',
            label: translate('column_verdict', { namespace: NAMESPACE }),
            width: '120px',
            renderer: VerdictCell
        },
        { dataKey: 'reason', label: translate('column_reason', { namespace: NAMESPACE }) }
    ];
    if (templates.length === 0) {
        return (React.createElement(Text, { variant: "body", as: "p" }, translate('empty', { namespace: NAMESPACE })));
    }
    return React.createElement(Table, { data: templates, columns: columns, getItemId: (item) => item.templateId });
}
export default TemplateVerdictTable;
